<template>
  <!-- Begin Page Content -->
  <div class="container-fluid">
    <!-- Page Heading -->
  
    <div class="row">
      <div class="col-md-12">
  
  
        <!-- <select v-model="selected_database">
              <option disabled value="">Please select one</option>
              <option v-for="option in databases" v-bind:value="option.dbname">
                {{ option.dbname }}
              </option>
            </select>
      
      <vue-bootstrap-typeahead
        v-model="selected_database"
        :data="databases"
        :serializer="s => s.dbname"
        @hit="onDatabaseSelected"
        placeholder="qf_core"
      ></vue-bootstrap-typeahead> -->
  
        <pre style="display: none">
          debug: 
          {{selected_database}}
          {{selected_zone}}
          {{selected_sql_id}}
        </pre>

        <div class="row">
          <div class="col-md-2">
             <v-select 
              label="name" 
              :options="zones" 
              v-model="selected_zone" 
              :reduce="r => r.id" 
              :dropdown-should-open="databaseSelectOpen">
            </v-select>
          </div>
          <div class="col-md-2">
            <v-select label="dbname" :options="databases" v-model="selected_database"
             :value="$store" :reduce="r => r.dbname" :dropdown-should-open="databaseSelectOpen"
             ></v-select>
          </div>
          <div class="col-md-2">
            <input class="form-control" v-model="selected_database">
          </div>
          <div class="col-md-2">
            <v-select :options="tables"></v-select>
          </div>
          <div class="col-md-4 float-left">
            <button class="btn btn-danger" @click="deleteThisSqlBookmark">delete this bookmark</button>
            <button class="btn btn-danger" @click="deleteAllSqlBookmark">delete all bookmark</button>
          </div>
        </div>

        <v-select ref="sql_bookmark" :options="sql_bookmark" 
          :get-option-label="_bookmarkLabel" 
          label="query" @search="searchSql" @input="onSelectSqlBookmark">
          <template v-slot:option="option">
            <div>
              <i>{{option.id}}</i> 
              &nbsp;
              <span class="badge badge-primary">{{option.database}}</span>
              {{option.query}}
                <!-- <pre>{{previewSql(option.query)}}</pre> -->
            </div>
          </template>
        </v-select>
        <!-- <span>{{selected_database}}</span> -->
  
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <!-- <label for="message">{{txt('Query')}}</label> -->
              <!-- <textarea class="form-control" 
                    id="query" v-model="selected_sql" required rows="5" :placeholder="txt('Type message...')"></textarea> -->
              <prism-editor class="my-editor" v-model="selected_sql" :highlight="highlighter" line-numbers></prism-editor>
            </div>
          </div>
        </div>
        <!-- <button @click="saveSqlBookmark">save</button> -->
        <div>{{selected_sql_id}}</div>
        
        <!-- <button @click="foo">foo</button> -->
  
  
  
        <!-- <button @click="submitSql">submit</button> -->
        <!-- <pre>{{databases|json}}</pre> -->
  
  
        <div class="table-responsive">
          <table id="table" class="table table-bordered table-striped table-sm table-hover"></table>
        </div>
      </div>
    </div>
  
    <div class="row">
      <div class="col-md-12">
        <div class="form-group row">
          <input class="form-control" type="text" id="merchant" 
            @change="searchMerchant" 
            v-model="merchantTerm" placeholder="search term">
        </div>
  
        <!-- <input type="text" id="merchant2" v-model="merchantTerm"> -->
        <!-- {{merchantTerm}} -->
      </div>
    </div>
  
    <pre class="text-left">{{merchantData}}</pre>
  
  
    <br><br><br><br><br><br><br>
  
  </div>
  
  <!-- /.container-fluid -->
</template>

<script>
  import moment from 'moment';
  import foo from '../services/QfModel';
  import {
    Merchant
  } from '../services/QfModel';
  
  import axios from 'axios';
  import _ from 'lodash';
  import hotkeys from 'hotkeys-js';
  
  // import Prism Editor
  import {
    PrismEditor
  } from 'vue-prism-editor';
  import 'vue-prism-editor/dist/prismeditor.min.css'; // import the styles somewhere
  
  // import highlighting library (you can use any library you want just return html string)
  // const Prism = require('prismjs');
  import {
    highlight,
    languages
  } from 'prismjs/components/prism-core';
  // const loadLanguages = require('prismjs/components/');
  // loadLanguages(['sql'])
  
  // https://prismjs.com/#supported-languages
  // import 'prismjs/components/prism-clike';
  import 'prismjs/components/prism-sql';
  // import 'prismjs/components/prism-javascript';
  // import 'prismjs/themes/prism-okaidia.css'; // import syntax highlighting styles
  import 'prismjs/themes/prism-tomorrow.css'; // import syntax highlighting styles
  
  import vSelect from "vue-select";
  import "vue-select/dist/vue-select.css";
  
  import toast from "../services/toast";

  import {encode} from 'html-entities';
  
  
  export default {
    name: "QFQuery",
    components: {
      vSelect,
      PrismEditor,
    },
  
    beforeRouteEnter: function(to, from, next) {
      next();
    },
  
    beforeDestroy: function() {
      // hotkeys.unbind('*')
      // hotkeys.unbind('cmd+enter')
      hotkeys.deleteScope('query')
    },
  
    async mounted() {
    
      toast.success("init ok");
      // console.log({foo})
  
      this.sql_bookmark = this.searchSql(null) // get all
  
      this._populate()

      // console.log(this.$store)
  
      await this._registerHotKeys()

      await this.searchMerchant()
  
      if (!$('#accordionSidebar').hasClass('toggled')) {
        $('#accordionSidebar').addClass('toggled')
      }
  
      try {
        let {
          data
        } = await axios.post('http://localhost:3000', {
          action: 'sql_database'
        }, {
          timeout: 5000
        })
  
        this.databases = data.data
        if (!this.selected_database) {
          this.selected_database = _.get(
            _.first(data.data), 0
          )
        }
      } catch (err) {
        toast.error(err.message)
      }
  
      // console.info(data)
    },
  
    data: function() {
      return {
        databases: [],
        tables: [],

        selected_database: 'qf_trade',
        selected_sql: "-- no previous query",
        selected_sql_id: null,
        sql_bookmark: [],
        selected_zone: 1,

        env: [
          // TODO hk / bj
        ],

        zones: [
          {
            id: 1,
            name: 'HK',
          },
          {
            id: 11,
            name: 'Oversea QA',
          },
        ],
  
        merchantTerm: '',
        merchantData: [],
  
        testData: {
          foo: "bar"
        },
      };
    },
    watch: {
      async selected_database(v) {
        toast.success(`selected db: ${this.selected_database}`)
        v && localStorage.setItem('selected_database', v)

        await this.updateDatabaseTable()
      },
      selected_zone(v) {
        // toast.success(`selected db: ${this.selected_database}`)
        v && localStorage.setItem('selected_zone', v)
      },
      selected_sql(v) {
        // toast.success(`selected db: ${this.selected_sql}`)
        v && localStorage.setItem('selected_sql', v)
      },
      selected_sql_id(v) {
        // toast.success(`selected db: ${this.selected_sql}`)
        v && localStorage.setItem('selected_sql_id', v)
      },
      // sql_bookmark(v){
      //   this.sql_bookmark.push({query: this.selected_sql})
      //   localStorage.setItem('sql_bookmark', JSON.stringify(this.sql_bookmark))
      // },
      // merchantTerm(v){
      //   this.searchMerchant()
      // }
    },
    methods: {
  
      async updateDatabaseTable(){
        if (!this.selected_database){
          return
        }

        let sql = 'show tables'

        let {
          data: {
            data = [],
            msg = null,
            success,
          }
        } = await axios.post('http://localhost:3000', {
          action: 'sql_query',
          database: this.selected_database,
          sql,
          zone_id: this.selected_zone,
        }, {
          timeout: 15 * 1000
        })

        this.tables = _.flatten(_.map(data, r => _.values(r)))
      },

      async searchMerchant() {
        this.merchantTerm && localStorage.setItem('merchantTerm', this.merchantTerm)
  
        // _.debounce(async function() {
          try {
            this.merchantData = [`searching.. ${this.merchantTerm}`]
            toast.success(`searching.., "${this.merchantTerm}"`)
            this.merchantData = await Merchant.search(this.merchantTerm)
            console.log('-------done', this.merchantData, this.merchantTerm)
            toast.success("DONE")
          }
          catch (err){
            toast.error(err.message)
          }
          // 宗哲
          // info - sky
        // }, 500)
      },
  
      _populate() {
        // populate
        if (localStorage.getItem('selected_database'))
          this.selected_database = localStorage.getItem('selected_database')
        if (localStorage.getItem('selected_sql_id'))
          this.selected_sql = localStorage.getItem('selected_sql_id')
        if (localStorage.getItem('selected_sql'))
          this.selected_sql = localStorage.getItem('selected_sql')
        if (localStorage.getItem('selected_zone'))
          this.selected_zone = localStorage.getItem('selected_zone')
        if (localStorage.getItem('merchantTerm'))
          this.merchantTerm = localStorage.getItem('merchantTerm')
  
      },
      foo() {
        this.$forceUpdate()
        // this.$refs.sql_bookmark.dropdownOpen = true
        console.log('------adsadasds', this.$refs)
        window.tmp = this.$refs
      },

      previewSql(v){
        return v.substring(0, 100)
      },

  
      _bookmarkLabel(option) {
        return `${option.database} | ${option.query}`
      },
  
      onSelectSqlBookmark(r) {
        if (!r) {
          return
        }
  
        // console.log(this.$refs.sql_bookmark)
  
        toast.success(`onSelectSqlBookmark, id: ${_.get(r, 'id', '(no id)')}, db: ${r.database}`)
        // console.log(r)
        r.query && (this.selected_sql = r.query)
        r.database && (
          (this.selected_database = r.database)
          && (this.selected_sql_id = _.get(r, 'id', null))
        )
      },
  
      deleteThisSqlBookmark() {
        if (!this.selected_sql || !!this.selected_databsae) {
          return
        }

        let rs = this.sql_bookmark

        let res = _.findIndex(rs, {
          id: this.selected_sql_id,
        })
        if (res === -1){
          res = _.findIndex(rs, {
            query: this.selected_sql,
            database: this.selected_database
          })
        }
        if (res === -1){
          toast.error(`seems not found! result: ${res}`)
          return false
        }
  
        // remove by ID
        if (this.selected_sql_id){
          _.remove(rs, {
            id: this.selected_sql_id,
          })
        }
        else {
          toast.success(`fallback coz no ID`)

          _.remove(rs, {
            query: this.selected_sql,
            database: this.selected_database
          })
        }

        this.sql_bookmark = rs 
        // trigger v-select update
        if (_.get(this.sql_bookmark, 0)){
          this.sql_bookmark.splice(0, 1, _.get(this.sql_bookmark, 0))
        }
        localStorage.setItem('sql_bookmark', JSON.stringify(this.sql_bookmark))
  
        toast.success(`DELETED, page should re-render`)
  
        this.selected_sql_id = null
        this.selected_sql = null
        localStorage.removeItem('selected_sql')
        localStorage.removeItem('selected_sql_id')

        this.$forceUpdate()
      },
  
      deleteAllSqlBookmark() {
        if (confirm("sure?")) {
          localStorage.removeItem('sql_bookmark')
          this.sql_bookmark = []
  
          toast.success(`DELETED`)
        } else {
          toast.success(`not processed`)
        }
      },
  
      saveSqlBookmark(saveNew=false) {
  
        if (!this.selected_sql) {
          return
        }
  
        // let result = _.find(this.sql_bookmark, {
        //   query: this.selected_sql,
        //   database: this.selected_database
        // })
        // if (result) {
        //   return toast.error('saved already')
        // }

        // console.log({
        //   result,
        //   size: _.size(result)
        // })
  
        if (!this.selected_sql_id || saveNew){
          this.selected_sql_id = moment().format('Y-MM-DD HH:mm:ss')
        }

        let res = _.findIndex(this.sql_bookmark, {
          id: this.selected_sql_id
        })

        // push or replace
        if (res === -1){
          this.sql_bookmark.push({
            query: this.selected_sql,
            database: this.selected_database,
            id: this.selected_sql_id
          })
        }
        else {
          this.sql_bookmark.splice(res, 1, {
            query: this.selected_sql,
            database: this.selected_database,
            id: this.selected_sql_id
          })
        }

        localStorage.setItem('sql_bookmark', JSON.stringify(this.sql_bookmark))
  
        toast.success(`saved bookmark, id : ${this.selected_sql_id}`)
      },
  
      getSql() {
  
      },
  
      searchSql(term, loading = null) {
        let str = localStorage.getItem('sql_bookmark')
  
        let data
        if (!str) {
          data = []
        } else {
          data = JSON.parse(str)
        }
  
        if (term === null) {
          return data
        }
  
        // console.log('----------------searchSql', data)
        return _.filter(data, r => {
          let reg = new RegExp(term, 'g')
          return reg.test(r.query)
        })
      },
  
      highlighter(code) {
        // console.log(languages)
        // const html = Prism.highlight(code, Prism.languages.sql, 'sql');
        // return html
  
        return highlight(code, languages.sql); // languages.<insert language> to return html with markup
      },
  
      databaseSelectOpen({
        noDrop,
        open,
        mutableLoading
      }) {
        // return true
        return noDrop ? false : open && !mutableLoading;
      },
  
      onDatabaseSelected($event) {
        this.selected_database = $event.dbname
        toast.success(`selected db: ${this.selected_database}`)
      },
  
      async _registerHotKeys() {
  
        let self = this
        let scope = 'query'
  
        hotkeys.filter = function(event) {
          return true;
        }
  
        hotkeys('cmd+s', {
          scope,
          // element: document.getElementById('query'),
        }, function(event, handler) {
          // Prevent the default refresh event under WINDOWS system
          event.preventDefault()
          self.saveSqlBookmark()
          // hotkeys.shift && console.log('asdadsadasd')
        });

        // hotkeys('*', {
        //   scope,
        //   // element: document.getElementById('query'),
        // }, function(event, handler) {
        //   console.log('key pressed', event)
        // });

        hotkeys('cmd+shift+s,command+shift+s,cmd+alt+s', {
          scope,
          // element: document.getElementById('query'),
        }, function(event, handler) {
          // Prevent the default refresh event under WINDOWS system
          event.preventDefault()
          self.saveSqlBookmark(true)
        });

        hotkeys('cmd+r', {
          scope,
          // element: document.getElementById('query'),
        }, function(event, handler) {
          // Prevent the default refresh event under WINDOWS system
          event.preventDefault()
          
          if (confirm('refresh page ?')){
            window.location = window.location.href
          }
        });
  
        hotkeys('cmd+enter', {
          scope,
          // element: document.getElementById('query'),
        }, function(event, handler) {
          // Prevent the default refresh event under WINDOWS system
          event.preventDefault()
          self.submitSql()

          // return false
        });
  
        hotkeys.setScope('query')
      },
  
      buildTable(data) {
  
  
        var myList = [{
            "name": "abc",
            "age": 50
          },
          {
            "age": "25",
            "hobby": "swimming"
          },
          {
            "name": "xyz",
            "hobby": "programming"
          }
        ];
        myList = data
  
        // Builds the HTML Table out of myList.
        function buildHtmlTable(selector) {
          $(selector).html('');
  
          var columns = addAllColumnHeaders(myList, selector);
  
          for (var i = 0; i < myList.length; i++) {
            var row$ = $('<tr/>');
            for (var colIndex = 0; colIndex < columns.length; colIndex++) {
              var cellValue = myList[i][columns[colIndex]];
              if (cellValue == null) cellValue = "";

              cellValue = encode(cellValue)
              row$.append($('<td/>').html(cellValue));
            }
            $(selector).append(row$);
          }
        }
  
        // Adds a header row to the table and returns the set of columns.
        // Need to do union of keys from all records as some records may not contain
        // all records.
        function addAllColumnHeaders(myList, selector) {
          var columnSet = [];
          var headerTr$ = $('<tr/>');
  
          for (var i = 0; i < myList.length; i++) {
            var rowHash = myList[i];
            for (var key in rowHash) {
              if ($.inArray(key, columnSet) == -1) {
                columnSet.push(key);
                headerTr$.append($('<th/>').html(key));
              }
            }
          }
          $(selector).append(headerTr$);
  
          return columnSet;
        }
        buildHtmlTable('#table')
      },
      async submitSql() {
        this.buildTable([{
          'loading..': '^o^\''
        }])

        let sql = this.selected_sql
        if (!sql.includes('limit ')){
          sql += " limit 1000"
        }
  
        try {
          let {
            data: {
              data = [],
              msg = null,
              success,
            }
          } = await axios.post('http://localhost:3000', {
            action: 'sql_query',
            database: this.selected_database,
            sql,
            zone_id: this.selected_zone,
          }, {
            timeout: 15 * 1000
          })
  
          if (!success) {
            toast.error(`sql fail, msg: ${msg}`);
          } else {
            toast.success(`sql ok, ${_.size(data)} rows`);
          }
  
          if (_.size(data)) {
            this.buildTable(data)
          } else {
            this.buildTable([{
              'no result': '><"'
            }])
          }
        } catch (err) {
          toast.error(`fatal: ${err.message}`);
        }
  
      },
    }
  };
</script>

<style scoped>
  td.remove {
    text-align: center;
  }
  
  td.remove a {
    cursor: pointer;
  }
  
  button.btn.payment {
    margin-bottom: 5px;
  }
  
  
  /* required class */
  
  .my-editor {
    /* we dont use `language-` classes anymore so thats why we need to add background and text color manually */
    background: #2d2d2d;
    color: #ccc;
    /* you must provide font-family font-size line-height. Example: */
    font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
    font-size: 14px;
    line-height: 1.5;
    padding: 5px;
  }
  
  
  /* optional class for removing the outline */
  
  .prism-editor__textarea:focus {
    outline: none;
  }
</style>

<style>
  .my-editor pre {
    color: #ccc;
  }
  
  .prism-editor-wrapper .prism-editor__editor,
  .prism-editor-wrapper .prism-editor__textarea {
    padding: 8px 8px 20px 8px !important
  }
</style>
